import styled from 'styled-components';
import {toRem} from 'shared/helpers';
import {COLORS} from 'shared/consts';

export const HiveMapModalFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)} ${toRem(12)};
  line-height: ${24 / 16};

  p {
    display: flex;
    align-items: flex-start;
    gap: ${toRem(4)};
    font-size: ${toRem(14)};

    span {
      &:first-child {
        color: ${COLORS.FG.MUTED};
      }
    }
  }
`;
